import(/* webpackMode: "eager" */ "/learn-web/apps/learn/app/error.tsx");
